// // Toaster Setup
// import { Toast, ToastrService } from 'ngx-toastr';

// // Used in dialog.component.ts
// export const toasterConfig: ToasterConfig = new ToasterConfig({
//   positionClass: 'toast-top-right', // toast-top-full-width
//   showCloseButton: { warning: true, error: true, info: true, success: true },
//   tapToDismiss: true,
//   timeout: 5000,
//   newestOnTop: true,
//   animation: 'fade', // 'fade', 'flyLeft', 'flyRight', 'slideDown', 'slideUp'
//   mouseoverTimerStop: true,
//   limit: 5
// });

export enum ToastLevel {
  Information,
  Success,
  Warning,
  Error,
}
